module.exports = __webpack_public_path__ + "static/media/shutterstock.84f38e2c.png";